import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-accordion-custom',
  templateUrl: './accordion-custom.component.html',
  styleUrls: ['./accordion-custom.component.scss']
})
export class AccordionCustomComponent {
  @Input() isExpanded: boolean = false;
  @Input() showDivider: boolean = false;

  toggle() {
    this.isExpanded = !this.isExpanded;
  }
}
